import React from 'react';
import T from 'prop-types';
import { clickContinue } from 'srcAlias/client/utils/clickContinue';
import { get, has } from 'lodash-es';
import {
  getUrlParametersList,
  modifyUrl,
} from 'srcAlias/client/utils/urlParameters';
import { callTrackEventAnalyticsFunction } from 'srcAlias/client/global/customHooks/useTrackEventAnalytics';
import hooks from 'hooksAlias';

const AcceptPageRedirectionNonEquitiesProduct = ({
  pageName,
  queryParams,
  productType,
  productID,
}) => {
  const HorizontalRuleHook = get(
    hooks,
    'horizontalRule.HorizontalRuleHook',
    () => null
  );
  const hasButtonSection = has(hooks, 'decision.continueButton.ButtonSection');

  const ButtonSection = get(
    hooks,
    'decision.continueButton.ButtonSection',
    () => null
  );
  const continueButtonClick = () => {
    callTrackEventAnalyticsFunction(
      'onClick',
      'continueButtonClickFromAcceptPage',
      {}
    );

    clickContinue(
      pageName,
      modifyUrl(queryParams, `${productType}_${productID}`)
    );
  };

  return (
    <>
      <form
        action={modifyUrl(queryParams, `${productType}_${productID}`)}
        method="GET"
      >
        {getUrlParametersList(
          modifyUrl(queryParams, `${productType}_${productID}`)
        ).map((item) => (
          <input
            key={item.name}
            type="hidden"
            name={item.name}
            value={item.value}
          />
        ))}
        <HorizontalRuleHook />
        {hasButtonSection && (
          <ButtonSection continueButtonClick={continueButtonClick} />
        )}
      </form>
    </>
  );
};

AcceptPageRedirectionNonEquitiesProduct.propTypes = {
  pageName: T.string,
  queryParams: T.object,
  productType: T.string,
  productID: T.string,
};

export default AcceptPageRedirectionNonEquitiesProduct;
